// dostepZrodel.ts — czy TEN użytkownik zobaczy dane z danego źródła.
//
// ┌─ CO SIĘ ZMIENIŁO W SAMYM PYTANIU ───────────────────────────────────────────────────────────┐
// │ Ekrany pytały dotąd `auth.connected('drive')` — czyli „czy użytkownik zalogował się także   │
// │ do systemu kierowców". Odpowiedź „nie" prowadziła do DRUGIEGO formularza logowania.         │
// │                                                                                              │
// │ Po przejściu na jedno logowanie to pytanie przestało istnieć: do źródeł chodzi backend      │
// │ tożsamością serwisową, więc nie ma czegoś takiego jak „użytkownik niepodłączony do Drive".  │
// │                                                                                              │
// │ Zostało pytanie INNE i nadal potrzebne: czy ten użytkownik ma PRAWO oglądać te dane. Rola   │
// │ bez zakresu, którego źródło potrafi dotrzymać, nie dostanie z niego nic — i ekran ma o tym  │
// │ wiedzieć ZANIM wyśle żądanie, żeby nie obiecywać zawartości, która wróci odmową.            │
// │                                                                                              │
// │ To NIE JEST autoryzacja. Autoryzacja zapada na serwerze, przy każdym żądaniu. To jest       │
// │ wyłącznie powód, dla którego nie rysujemy ekranu prowadzącego donikąd.                      │
// └──────────────────────────────────────────────────────────────────────────────────────────────┘
import type { AuthContextValue } from './types';

/** Dane o dostawach: Drive zna wszystkie trzy role, więc decyduje samo uprawnienie. */
export function czyWidziDostawy(auth: AuthContextValue): boolean {
  return auth.status === 'authenticated' && auth.has('analytics.delivery.read');
}

/**
 * Dane sprzedażowe CRM.
 *
 * Backend Control Center odmawia CRM rolom, których zakresu CRM nie potrafi dotrzymać — model
 * zakresu najemcy CRM zna dziś wyłącznie rolę globalną. Interfejs odwzorowuje tę odmowę, zamiast
 * pokazywać ekran, który skończy się komunikatem 403.
 */
export function czyWidziSprzedaz(auth: AuthContextValue): boolean {
  return auth.status === 'authenticated' && auth.has('analytics.sales.read');
}
